import { render, staticRenderFns } from "./DestinoPage.vue?vue&type=template&id=c5033980"
import script from "./DestinoPage.js?vue&type=script&lang=js&external"
export * from "./DestinoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports